import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest
  const [token, setToken] = useState(() => localStorage.getItem("sparkora_token"));

  useEffect(() => {
    let ignore = false;
    async function load() {
      if (!token) {
        setUser(null);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        if (!ignore) setUser(data);
      } catch {
        if (!ignore) {
          localStorage.removeItem("sparkora_token");
          setToken(null);
          setUser(null);
        }
      }
    }
    load();
    return () => { ignore = true; };
  }, [token]);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sparkora_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }

  function logout() {
    localStorage.removeItem("sparkora_token");
    sessionStorage.removeItem("sparkora_admin_token");
    setToken(null);
    setUser(null);
  }

  async function viewAs(uid) {
    const { data } = await api.post(`/auth/view-as/${uid}`);
    sessionStorage.setItem("sparkora_admin_token", localStorage.getItem("sparkora_token"));
    localStorage.setItem("sparkora_token", data.token);
    setUser(data.user);
    setToken(data.token);
  }

  function exitViewAs() {
    const own = sessionStorage.getItem("sparkora_admin_token");
    sessionStorage.removeItem("sparkora_admin_token");
    if (!own) return logout();
    localStorage.setItem("sparkora_token", own);
    setUser(undefined);
    setToken(own);
  }

  return (
    <AuthContext.Provider value={{ user, token, login, logout, setUser, viewAs, exitViewAs }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}

export const ROLE_LABELS = {
  master_admin: "Master Admin",
  super_admin: "Super Admin",
  principal: "Principal",
  teacher: "Teacher",
  accountant: "Accountant",
  parent: "Parent",
  hr_manager: "HR Manager",
  coordinator: "Coordinator",
  transport_staff: "Transport Staff",
  staff: "Staff",
  center_head: "Center Head",
};
